module.exports = __webpack_public_path__ + "static/max-fac3427ac340f4861636cf39bfe7f270.png";